import { action } from "typesafe-actions";
import { ICliam } from "./claims.types";
import { IDataTableV2DateState } from "../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { IDatatableV2AdvancedSearchFilter } from "../../components/TableV2/preDefinedPlugins/SearchFilter/SearchFilter.types";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { AnyAction } from "redux";
import { saveLoaderCompleted, saveLoaderProgress, showMessage } from "../messages/messagesActions";
import { api } from "../../api/api";

export const FETCH_CLAIMS_LIST_INPROGRESS = "FETCH_CLAIMS_LIST_INPROGRESS";
export const FETCH_CLAIMS_LIST_SUCCESS = "FETCH_CLAIMS_LIST_SUCCESS";
export const FETCH_CLAIMS_LIST_FAILED = "FETCH_CLAIMS_LIST_FAILED";

export const fetchClaimsListProgress = () =>
  action(FETCH_CLAIMS_LIST_INPROGRESS);
export const fetchClaimsListSuccess = (
  claims: ICliam[],
  totalRecords: number
) => action(FETCH_CLAIMS_LIST_SUCCESS, { claims, totalRecords });
export const fetchClaimsListFailed = () => action(FETCH_CLAIMS_LIST_FAILED);

export const fetchClaimsListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    limit: number,
    status: string,
    date: IDataTableV2DateState["dates"],
    searchValue: IDatatableV2AdvancedSearchFilter
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchClaimsListProgress());
      let finalUrl = `/policy/get-policy-auto-driver-and-habitational-claims?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${date.fromDate}&to_date=${date.toDate}`;
      if (searchValue.length > 0) {
        finalUrl = `/policy/get-policy-auto-driver-and-habitational-claims?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&advanceFilter=${JSON.stringify(searchValue)}`;
      }
      if (status !== "-1") {
        finalUrl += "&status=" + status;
      }
      const res = await api.get(finalUrl);
      const data: ICliam[] = res.data.data;
      const totalRecords = res.data.totalRecords;

      dispatch(fetchClaimsListSuccess(data, totalRecords));
    } catch (err: any) {
      dispatch(fetchClaimsListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

      export const downloadClaimsPDFAsync =
        (
          customerPolicyId: number,
          incremental_number: number,
          getBufferOnly?: (buffer: string) => void
        ): ThunkAction<void, IStoreState, {}, AnyAction> =>
        async (dispatch, getState) => {
          try {
            dispatch(saveLoaderProgress());
            const res = await api.get(
              `/policy/auto-driver-and-habitational-claims-pdf?customer_policy_id=${customerPolicyId}&incremental_number=${incremental_number}&is_auto_driver_and_habitational_claims_preview=true`,
              {
                responseType: "arraybuffer",
              }
            );
      
            const pdfBuffer = res.data;
      
            const pdfBlob = new Blob([pdfBuffer], { type: "application/pdf" });

            if(getBufferOnly){
              getBufferOnly(pdfBuffer)
              return;
            }
      
            const pdfUrl = URL.createObjectURL(pdfBlob);
      
            const link = document.createElement("a");
            link.href = pdfUrl;
            link.download = "downloaded.pdf";
            link.click();
      
            URL.revokeObjectURL(pdfUrl);
          } catch (err: any) {
            dispatch(
              showMessage({
                type: "error",
                message: err.response.data.message,
                displayAs: "snackbar",
              })
            );
          } finally {
            dispatch(saveLoaderCompleted());
          }
        };
      export const previewClaimsPDFAsync =
        (
          customerPolicyId: number,
          incremental_number: number
        ): ThunkAction<void, IStoreState, {}, AnyAction> =>
        async (dispatch, getState) => {
          try {
            dispatch(saveLoaderProgress());
            const res = await api.get(
              `/policy/auto-driver-and-habitational-claims-pdf?customer_policy_id=${customerPolicyId}&incremental_number=${incremental_number}`
            );
      
            for (const key in res.data.data) {
              const newTab = window.open("", "_blank");
              if (newTab) {
                newTab.document.write(res.data.data[key]);
                newTab.document.close();
              }
            }
          } catch (err: any) {
            // dispatch(fetchCommAutomobileLiabilitySlipsListFailed());
            dispatch(
              showMessage({
                type: "error",
                message: err.response.data.message,
                displayAs: "snackbar",
              })
            );
          } finally {
            dispatch(saveLoaderCompleted());
          }
        };
  


      export const previewCommAutomobilePDFApplications =
        (
          customerPolicyId: number,
          incremental_number: number
        ): ThunkAction<void, IStoreState, {}, AnyAction> =>
        async (dispatch, getState) => {
          try {
            dispatch(saveLoaderProgress());
            const res = await api.get(
              `/policy/get-commauto-and-automobile-application-pdf?policy=commauto&customer_policy_id=${customerPolicyId}&incremental_number=${incremental_number}&is_commauto_automobile_application_preview=true`
            );
      
            for (const key in res.data.data) {
              const newTab = window.open("", "_blank");
              if (newTab) {
                newTab.document.write(res.data.data[key]);
                newTab.document.close();
              }
            }
          } catch (err: any) {
            // dispatch(fetchCommAutomobileLiabilitySlipsListFailed());
            dispatch(
              showMessage({
                type: "error",
                message: err.response.data.message,
                displayAs: "snackbar",
              })
            );
          } finally {
            dispatch(saveLoaderCompleted());
          }
        };
  

  export const CLEAR_CLAIMS_STATE = "CLEAR_CLAIMS_STATE";
export const clearClaimsState = () => action(CLEAR_CLAIMS_STATE);